export const mockTestimonials = [
  {
    id: 1,
    name: '田中 美香',
    age: '小学4年生',
    avatar: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/d39f5bc9a95d2c64a5518397b6f3e517.jpeg',
    content: 'みんなでおしゃべりしながら英語を覚えていくような授業がとても楽しいです！友達もたくさんできて、毎回のレッスンが待ち遠しいです。先生たちもとても優しくて、分からないことがあっても丁寧に教えてくれます。'
  },
  {
    id: 2,
    name: '佐藤 健太',
    age: '中学2年生',
    avatar: 'https://public.readdy.ai/ai/img_res/e11818fb146b3d02e826c9de1ae0edf1.jpg',
    content: '最初は英語が苦手でしたが、先生方の分かりやすい指導のおかげで、今では英検準2級に合格することができました。学校の成績も大幅にアップして、英語が得意科目になりました。'
  },
  {
    id: 3,
    name: '山田 由紀子',
    age: '会社員・28歳',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20businesswoman%20in%20her%20late%20twenties%20with%20shoulder-length%20black%20hair%20wearing%20business%20casual%20attire%20in%20a%20modern%20office%20environment%20with%20natural%20lighting&width=120&height=120&seq=student3&orientation=squarish',
    content: '仕事で英語が必要になり、こちらの教室に通い始めました。オンラインレッスンも充実していて、忙しい私でも続けることができています。実践的な会話練習のおかげで、海外の取引先との会議でも自信を持って発言できるようになりました。'
  },
  {
    id: 4,
    name: '鈴木 雅子',
    age: '主婦・45歳',
    avatar: 'https://readdy.ai/api/search-image?query=Warm%20Japanese%20middle-aged%20woman%20with%20gentle%20smile%20and%20neat%20black%20hair%20wearing%20comfortable%20casual%20clothing%20in%20a%20cozy%20home%20setting%20with%20soft%20natural%20lighting&width=120&height=120&seq=student4&orientation=squarish',
    content: '子育てが落ち着いて、昔から憧れていた英会話を始めました。アットホームな雰囲気で、同世代の仲間もたくさんいて楽しく学べています。先日、家族旅行で海外に行った際に、現地の方と英語で会話ができて、とても嬉しかったです。'
  }
];